import React, { useEffect, useState } from "react";
import "./CardSixScreen.css";
import mixpanel from "../../mixpanel";
import Instagram from "../../assets/instagram.png";
import Substack from "../../assets/substack.png";
import Logo from "../../assets/logo.png";
import YouTubeProfile from "../../assets/youtube_profile.jpg";

const channels = [
  {
    img: Instagram,
    title: "Instagram ալիք",
    subtitle: "Գրառումներ, lifestyle և ավելին...",
    link: "https://www.instagram.com/girlsandfinances/",
    event: "channels_instagram_clicked",
  },
  {
    img: Substack,
    title: "Substack բլոգ",
    subtitle: "Նյուզլեթր, կրթական հոդվածներ, գրքեր/փոդքասթներ...",
    link: "https://girlsandfinances.substack.com/",
    event: "channels_substack_clicked",
  },
  {
    img: Logo,
    title: "Telegram համայնք",
    subtitle: "Ներդրողների համար ստեղծված տելեգրամյան ալիք",
    link: "https://t.me/+k_T6C2zXaDQ4NjY6",
    event: "channels_telegram_clicked",
  },
  {
    img: YouTubeProfile,
    title: "YouTube ալիք",
    subtitle: "Ներդրումային տեսաշարք և ֆինանսական կրթություն",
    link: "https://www.youtube.com/@girlsandfinances",
    event: "channels_youtube_clicked",
  },
];

export default function CardSixScreen() {
  const [cardsVisible, setCardsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCardsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const element = document.querySelector('.card-six-screen');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="card-six-screen">
      <div className="card-six-content">
        <h1 className="card-six-title">Ալիքներ</h1>
        <div className="channels-grid">
          {channels.map((channel, index) => (
            <a
              key={index}
              href={channel.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`channel-card ${cardsVisible ? 'fade-in' : ''}`}
              style={{ transitionDelay: `${index * 0.15}s` }}
              onClick={() => mixpanel.track(channel.event)}
            >
              <div className="channel-icon">
                <img src={channel.img} alt={channel.title} />
              </div>
              <h3 className="channel-title">{channel.title}</h3>
              <p className="channel-subtitle">{channel.subtitle}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
